// @flow

import { deactivateOaModalActions } from './deactivateOaModalActionCreator';

const initialState = {
  showDeactivateOaModal: false,
  deactivateOa: {
    isLoading: false,
    isLoaded: true,
    refreshTab: false,
    data: { status: null, val: null }
  }
};

const deactivateOaModalReducer = (
  state: Object = initialState,
  action: Object
) => {
  switch (action.type) {
    case deactivateOaModalActions.SHOW_DEACTIVATE_OA_MODAL:
      return { ...state, showDeactivateOaModal: action.payload };
    case deactivateOaModalActions.DEACTIVATE_OA_ACTION:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};

export default deactivateOaModalReducer;
